const apihost='https://api.insightnest.tech';
const authhost='https://auth.insightnest.tech';
const basehost='https://validator.insightnest.tech';
export {basehost,apihost, authhost};